
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { SiteLayoutType } from '../../../../../pagesPage/stateInterfaces';
import { ArticleImagesFullScreenGallery } from '../articleImagesFullScreenGallery/articleImagesFullScreenGallery';
import { ArticleImageGallery } from "./articleImageGalleryComponenta";


interface ArticleImageSliderGalleryComponentaProps {
    isLTR: boolean
    images: ArticleImageGallery[]
    articleId: string
    siteLayoutType: SiteLayoutType
    mainOptions: any
    componentaId?: string
    thumbOptions: any
    imagesJson?: string
    platform?: string
}

interface ArticleImageSliderGalleryComponentaState {
    currentIndex: number
    showFullScreenGallery: boolean
}

export default class ArticleImageSliderGalleryComponenta extends React.Component<ArticleImageSliderGalleryComponentaProps, ArticleImageSliderGalleryComponentaState> {

    constructor(props: ArticleImageSliderGalleryComponentaProps) {
        super(props);
        this.state = {
            currentIndex: 0,
            showFullScreenGallery: false
        };
    }

    public static siteScriptName = "ArticleImageSliderGalleryComponenta";
    private mainRef;
    private thumbsRef;
    private translateX = 0;
    private sliderRange;

    componentDidMount(): void {
        if (this.mainRef && this.thumbsRef && this.thumbsRef.splide) {
            this.mainRef.sync(this.thumbsRef.splide);
        }

        document.addEventListener('keydown', this.handleGlobalKeyDown, true);
        window.addEventListener('keydown', this.handleGlobalKeyDown, true);
        document.body.addEventListener('keydown', this.handleGlobalKeyDown, true);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.handleGlobalKeyDown, true);
        window.removeEventListener('keydown', this.handleGlobalKeyDown, true);
        document.body.removeEventListener('keydown', this.handleGlobalKeyDown, true);
    }

    handleComponentKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'F5' || event.keyCode === 116) {
            event.stopPropagation();
            return;
        }

        // Use event.code for language-independent key detection, fallback to keyCode
        if ((event.ctrlKey || event.metaKey)) {
            const code = (event.nativeEvent as any).code || event.key;
            const essentialCodes = ['KeyC', 'KeyV', 'KeyX', 'KeyA', 'KeyZ', 'KeyY', 'KeyS', 'KeyR', 'KeyT', 'KeyW', 'KeyN', 'KeyF'];
            const essentialKeys = ['c', 'v', 'x', 'a', 'z', 'y', 's', 'r', 't', 'w', 'n', 'f'];

            if (essentialCodes.includes(code) || essentialKeys.includes(event.key.toLowerCase())) {
                event.stopPropagation();
                return;
            }
        }
    }

    handleGlobalKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'F5' || event.keyCode === 116) {
            event.stopImmediatePropagation();
            return true;
        }

        if (event.ctrlKey || event.metaKey) {
            const code = (event as any).code || event.key;
            const essentialCodes = ['KeyC', 'KeyV', 'KeyX', 'KeyA', 'KeyZ', 'KeyY', 'KeyS', 'KeyR', 'KeyT', 'KeyW', 'KeyN', 'KeyF'];
            const essentialKeys = ['c', 'v', 'x', 'a', 'z', 'y', 's', 'r', 't', 'w', 'n', 'f'];

            if (essentialCodes.includes(code) || essentialKeys.includes(event.key.toLowerCase())) {
                event.stopImmediatePropagation();
                return true;
            }
        }

        if ((event.ctrlKey || event.metaKey) && event.shiftKey) {
            event.stopImmediatePropagation();
            return true;
        }
    }

    renderSlides = (isMainImage) => {
        return this.props.images.map((item, index) => {
            const { componentaId, siteLayoutType } = this.props;

            return (
                <SplideSlide key={item.imageId}>
                    {isMainImage && siteLayoutType === 'mobileApp' ?
                        <a data-href="image_gallery" href={`image_gallery?componentaId=${componentaId}&index=${index}&imageId=${item.imageId}&type=.jpg`}>
                            <img src={item.imageSrc} alt={item.caption} />
                        </a>
                        :
                        <img src={item.imageSrc} alt={item.caption} />}
                </SplideSlide>
            )
        })
    }

    handleSliderMove = (splideObj, index: number) => {
        this.setState({ currentIndex: index });
    }

    handleOpenGallery = () => {
        if (this.props.siteLayoutType === 'mobileApp') return;
        else {
            this.setState({ showFullScreenGallery: true })
            document.body.style.overflow = "hidden";
        }
    }

    handleCloseGallery = (index) => {
        this.setState({ showFullScreenGallery: false, currentIndex: index }, () => {
            this.thumbsRef.splide.Components.Controller.go(index)
        })
        document.body.style.overflow = "auto";
    }

    render() {

        const { images, mainOptions, thumbOptions, componentaId, siteLayoutType, imagesJson, articleId, isLTR } = this.props;
        const { currentIndex, showFullScreenGallery } = this.state;

        return (
            <div className="ArticleImageSliderGalleryComponenta" onKeyDown={this.handleComponentKeyDown}>
                <ArticleImagesFullScreenGallery
                    isLtr={isLTR}
                    images={images}
                    index={currentIndex}
                    articleId={articleId}
                    show={showFullScreenGallery}
                    open={this.handleOpenGallery}
                    siteLayoutType={siteLayoutType}
                    close={this.handleCloseGallery}
                />

                {siteLayoutType === 'mobileApp' && < script type="text/javascript" dangerouslySetInnerHTML={{ __html: `const galleryImagesArrayObjects_${componentaId} = ${imagesJson}` }} />}

                <div className="main-gallery">
                    {siteLayoutType === 'mobileApp' ?
                        <a data-href="image_gallery" href={`image_gallery?componentaId=${componentaId}&index=${currentIndex}&imageId=${images[currentIndex].imageId}&type=.jpg`}>
                            <div className="fullscreen-gallery-icon-pf"></div>
                        </a>
                        :
                        <div onClick={this.handleOpenGallery} className="fullscreen-gallery-icon-pf"></div>
                    }

                    <Splide
                        className="main-slider"
                        onMove={this.handleSliderMove}
                        ref={ref => this.mainRef = ref}
                        onClick={this.handleOpenGallery}
                        options={{ ...mainOptions, keyboard: false, wheel: false, releaseWheel: false, drag: true }}
                    >
                        {this.renderSlides(true)}
                    </Splide>

                    <div className="caption-credit">{`${images[currentIndex].caption} (${images[currentIndex].credit})`}</div>
                </div>

                <Splide
                    className="thumbnail-slider"
                    onMove={this.handleSliderMove}
                    ref={ref => this.thumbsRef = ref}
                    options={{ ...thumbOptions, keyboard: false, wheel: false, releaseWheel: false, drag: true }}
                >
                    {this.renderSlides(false)}
                </Splide>

                <div className="article-carousel-scroller-navigation">
                    <input
                        min="1"
                        type="range"
                        id="sliderRange"
                        className="slider"
                        value={`${currentIndex + 1}`}
                        max={this.props.images.length}
                        ref={ref => this.sliderRange = ref}
                        onChange={(e: any) => {
                            const index = parseInt(e.target.value, 10) - 1;
                            this.mainRef.splide.go(index);
                            this.handleSliderMove(this.mainRef.splide, index);
                        }}
                        style={{ '--slider-width': `${740 / this.props.images.length}px`, direction: isLTR ? 'ltr' : 'rtl' } as React.CSSProperties}
                    />
                </div>
            </div>
        );
    }
}